// Sets the browser tab title dynamically
// Usage: setPageTitle("Dashboard") -> "PSI360 · Dashboard"
// Usage: setPageTitle() -> "PSI360"
export const setPageTitle = (pageName) => {
  document.title = pageName ? `PSI360 · ${pageName}` : "PSI360";
};